"use strict";

var React = require('react');
var DataContext = React.createContext({});
var DataProvider = DataContext.Provider;
var DataConsumer = DataContext.Consumer;
var useDataContext = function useDataContext() {
  return React.useContext(DataContext);
};
var getDataContext = function getDataContext(dataId) {
  var ele = document.getElementById(dataId);
  return ele ? JSON.parse(ele.textContent) : {};
};
module.exports = {
  DataProvider: DataProvider,
  DataConsumer: DataConsumer,
  useDataContext: useDataContext,
  getDataContext: getDataContext
};